import { Entity } from "src/app/core/data/schema/entity";
export class Purchase extends Entity {

    static className = 'Transaction';
    static idField = 'skuPurchaseId';

    communityId: number;
    transactionHeadId: number;
    timestamp: Date;
    currency: string;
    status: PurchaseStatus;
    totalTax: number;
    subtotal: number;
    totalPaid: number;
    transactionToken: string;
    platform: string;
    refundToken: string;
    coupon: string;
    totalDiscount: number;
    provinceRateId: number;
    shippingAddress: string;
    billingAddress: string;
    isFulfilled: boolean;
    firstName: string;
    lastName: string;
    userEmail: string;
    phone: string;
    notes: string;
    customerName: string;
    purchases: PurchaseDetail[] = [];
    timestampDisplay = '';
    statusString = '';


    // platform taxes
    platformTax1: number;
    platformTax2: number;
    platformTax3: number;
    platformTax1Label: string;
    platformTax2Label: string;
    platformTax3Label: string;


    private totalWithTax: number;


    constructor(init?: Partial<Purchase>) {
        super('Transaction', null, 'transactions');
        Object.assign(this, init);

        this.timestamp = new Date(this.timestamp);
        this.timestampDisplay = this.timestamp.toDisplayString();
        this.purchases.mapObjectsTo(PurchaseDetail);

        switch (this.status) {
            case PurchaseStatus.Paid:
                this.statusString = 'Paid';
                break;
            case PurchaseStatus.Pending:
                this.statusString = 'Outstanding';
                break;
            case PurchaseStatus.Expired:
                this.statusString = 'Expired';
                break;
            case PurchaseStatus.Refunded:
                this.statusString = 'Refunded';
                break;
            case PurchaseStatus.Void:
                this.statusString = 'Void';
                break;
        }

        this.currency = this.currency.toUpperCase();

        this.totalWithTax = this.subtotal + this.totalTax;
    }

    get total() { return this.totalWithTax; }

    public static async fetchForCommunity() {
        return await Entity.factory.fetchObj(Purchase, 'transactions', `community`);
    }

    public static async load(id: number) {
        return await this.getByIdNoCache(Purchase, id, 'transactions');
    }

    public async getCheckoutUrl() {
        return await Entity.fetchUntyped('Preparing', 'transactions', `checkout/${this.transactionHeadId}`);
    }

    public static async cancelPurchase(id: number) {
        return await Entity.factory.post('Cancelling', null, 'transactions', `cancel/${id}`);
    }

    get paidFor() {
        return this.status == PurchaseStatus.Paid;
    }

}

export class PurchaseDetail {
    name: string;
    amount: number;
    currency: string;
    note: string;

    constructor(init?: Partial<PurchaseDetail>) {
        Object.assign(this, init);
        this.currency = this.currency.toUpperCase();
    }
}

export enum PurchaseStatus {
    Pending = 1,
    Paid = 2,
    Refunded = 3,
    Void = 4,
    Expired = 5
}